<template>
  <SpinnerOverlay/>
  <ConfirmDialog/>
  <!-- Auth pages (login/signup) will only show router-view -->
  <router-view v-if="!$route.meta.hideLayout" />
  
  <!-- Regular pages show full layout -->
  <div v-else class="d-flex vh-100">
    <!-- Sidebar -->
    <div 
      class="sidebar bg-dark text-white" 
      :class="{ 'collapsed': sidebarCollapsed }"
    >
      <div class="p-3 text-center border-bottom">
        <h4 class="m-0">
          <i class="bi bi-cash-coin fs-4"></i>
          <span v-if="!sidebarCollapsed" class="ms-2">POS System</span>
        </h4>
      </div>
      <ul class="nav flex-column p-2">
        <li class="nav-item">
          <router-link 
            to="/dashboard" 
            class="nav-link text-white" 
            :class="{ 'active': $route.path === '/dashboard' }"
          >
            <i class="bi bi-speedometer2 me-2"></i>
            <span v-if="!sidebarCollapsed">Dashboard</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link 
            to="/pos" 
            class="nav-link text-white" 
            :class="{ 'active': $route.path === '/pos' }"
          >
            <i class="bi bi-cash-stack me-2"></i>
            <span v-if="!sidebarCollapsed">POS</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link 
            to="/reports" 
            class="nav-link text-white" 
            :class="{ 'active': $route.path === '/reports' }"
          >
            <i class="bi bi-graph-up me-2"></i>
            <span v-if="!sidebarCollapsed">Reports</span>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- Main Content -->
    <div class="main-content flex-grow-1 bg-light">
      <!-- Top Navbar -->
      <nav class="navbar navbar-light bg-white border-bottom">
        <div class="container-fluid">
          <button class="btn btn-sm" @click="toggleSidebar">
            <i class="bi bi-list"></i>
          </button>
          <h5 class="m-0 ms-3">{{ currentPage }}</h5>
          <div class="ms-auto">
            <i class="bi bi-bell mx-3"></i>
            <i class="bi bi-person-circle"></i>
          </div>
        </div>
      </nav>

      <!-- Page Content -->
      <div class="p-4">
        <router-view /> <!-- Changed to router-view for proper routing -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import SpinnerOverlay from './components/animations/SpinnerOverlay.vue';
import ConfirmDialog from './components/animations/ConfirmDialog.vue';

const route = useRoute();
const sidebarCollapsed = ref(false);

const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value;
};

// Get current page from route
const currentPage = computed(() => {
  const routeName = route.name;
  return routeName ? routeName.charAt(0).toUpperCase() + routeName.slice(1) : 'Dashboard';
});
</script>

<style>
/* Your existing styles remain the same */
.sidebar {
  width: 250px;
  transition: width 0.3s;
}
.sidebar.collapsed {
  width: 60px;
}
.sidebar.collapsed .nav-link span {
  display: none;
}
.nav-link {
  border-radius: 5px;
  margin-bottom: 5px;
}
.nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
}
.nav-link.active {
  background: #0d6efd;
}
.main-content {
  overflow-y: auto;
}
</style>